import { expiringSoonStatus, type SegmentStatus, segmentStatus } from '@openx/types/segments';
import { firstLetterUppercase } from '@openx/utils/lib/firstLetterUppercase';
import type { GetDistinctSegmentStatusesQuery } from '../../../../graphql/query/segments/GetDistinctSegmentStatuses.generated';

export type SegmentStatusReduced = {
  displayName: string;
  status: SegmentStatus;
};

const initValue: SegmentStatusReduced[] = [{ displayName: 'Expiring soon', status: expiringSoonStatus }];

const isSegmentStatus = (status?: string | null): status is SegmentStatus => {
  return Object.values(segmentStatus).includes(status as SegmentStatus);
};

export const reduceSegmentStatuses = (
  statuses: GetDistinctSegmentStatusesQuery['segment_statuses']
): SegmentStatusReduced[] => {
  return statuses.reduce(
    (acc, { status }) => {
      if (isSegmentStatus(status)) {
        acc.push({ displayName: firstLetterUppercase(status.replaceAll('_', ' ')), status });
      }

      return acc;
    },
    [...initValue]
  );
};
